"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpinButtons = void 0;
exports.withSpinButtons = withSpinButtons;
var _react = _interopRequireWildcard(require("react"));
var _bignumber = require("bignumber.js");
require("./StepperInput.css");
var _excluded = ["min", "max", "step"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * @typedef {import('../BaseNumberInput').BaseNumberInputProps} BaseNumberInputProps
 *
 * @typedef {Object} SpinButtonProps
 * @property {number} [min] Optional minimum value.
 * @property {number} [max] Optional maximum value.
 * @property {number} [step] Optional step value.
 *
 * @typedef {BaseNumberInputProps & SpinButtonProps} NumberInputWithSpinButtonsProps
 */

var spinArrow = /*#__PURE__*/_react["default"].createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "8",
  height: "6",
  viewBox: "0 0 8 6",
  fill: "none"
}, /*#__PURE__*/_react["default"].createElement("path", {
  d: "M3.32124 0.375C3.62291 -0.125 4.37709 -0.125 4.67877 0.375L7.39383 4.875C7.6955 5.375 7.31841 6 6.71506 6H1.28494C0.681593 6 0.304501 5.375 0.606175 4.875L3.32124 0.375Z"
}));
var SpinButtons = exports.SpinButtons = function SpinButtons(_ref) {
  var onIncrease = _ref.onIncrease,
    onDecrease = _ref.onDecrease;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "step-buttons"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "step-button--up",
    onClick: onIncrease
  }, spinArrow), /*#__PURE__*/_react["default"].createElement("button", {
    className: "step-button--down",
    onClick: onDecrease
  }, spinArrow));
};
function withSpinButtons(WrappedComponent) {
  /**
   * @param {NumberInputWithSpinButtonsProps} props
   * @param {React.Ref<import('../BaseNumberInput').BaseNumberInputRef>} ref
   */
  return /*#__PURE__*/(0, _react.forwardRef)(function NumberInputWithSpin(_ref2, ref) {
    var _inputRef$current7;
    var min = _ref2.min,
      max = _ref2.max,
      step = _ref2.step,
      props = _objectWithoutProperties(_ref2, _excluded);
    /**
     * @type {React.Ref<import('../BaseNumberInput').BaseNumberInputRef>}
     */
    var inputRef = (0, _react.useRef)();
    (0, _react.useImperativeHandle)(ref, function () {
      return inputRef.current;
    });
    var onIncrease = (0, _react.useCallback)(function () {
      var _inputRef$current;
      var value = ((_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.getValue()) || (0, _bignumber.BigNumber)(0);
      var newValue = value.plus(step);
      if (typeof max !== 'undefined' && newValue.gte(max)) {
        newValue = (0, _bignumber.BigNumber)(max);
      }
      if (!value.eq(newValue)) {
        var _inputRef$current2, _inputRef$current3;
        (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 || (_inputRef$current2 = _inputRef$current2.inputEl) === null || _inputRef$current2 === void 0 || _inputRef$current2.focus();
        (_inputRef$current3 = inputRef.current) === null || _inputRef$current3 === void 0 || _inputRef$current3.setValue(newValue);
      }
    }, [max, step]);
    var onDecrease = (0, _react.useCallback)(function () {
      var _inputRef$current4;
      var value = ((_inputRef$current4 = inputRef.current) === null || _inputRef$current4 === void 0 ? void 0 : _inputRef$current4.getValue()) || (0, _bignumber.BigNumber)(0);
      var newValue = value.minus(step);
      if (typeof min !== 'undefined' && newValue.lte(min)) {
        newValue = (0, _bignumber.BigNumber)(min);
      }
      if (!value.eq(newValue)) {
        var _inputRef$current5, _inputRef$current6;
        (_inputRef$current5 = inputRef.current) === null || _inputRef$current5 === void 0 || (_inputRef$current5 = _inputRef$current5.inputEl) === null || _inputRef$current5 === void 0 || _inputRef$current5.focus();
        (_inputRef$current6 = inputRef.current) === null || _inputRef$current6 === void 0 || _inputRef$current6.setValue(newValue);
      }
    }, [min, step]);
    var onWheel = (0, _react.useCallback)(function (e) {
      e.preventDefault();
      if (e.deltaY < 0) {
        onIncrease();
      } else if (e.deltaY > 0) {
        onDecrease();
      }
    }, [onIncrease, onDecrease]);
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(WrappedComponent, _extends({}, props, {
      ref: inputRef,
      role: "spinbutton",
      onWheel: onWheel,
      "aria-valuemin": min,
      "aria-valuemax": max,
      "aria-valuenow": (_inputRef$current7 = inputRef.current) === null || _inputRef$current7 === void 0 || (_inputRef$current7 = _inputRef$current7.getValue()) === null || _inputRef$current7 === void 0 ? void 0 : _inputRef$current7.toNumber()
    })), /*#__PURE__*/_react["default"].createElement(SpinButtons, {
      onIncrease: onIncrease,
      onDecrease: onDecrease
    }));
  });
}